// api/v1/pallets/dashboard

import Http from '../http'

export default {
  indexPalletDashborad(filtering){
    let {form_id, start_date, end_date} = filtering
    return Http.get('/pallets/dashboard',{
      params:
      // JSON.stringify(
        {
          ...filtering
          //solution_id,
          //start_date,
          //end_date,
        }
      // )
    })
  },

  updatePalletsValues(data){
    return Http.put(`/pallets/dashboard/${data.id}`,{
      pallets: {
        ...data.pallets
      }
    })
  }
}